import * as React from "react";
import Svg, { Path } from "react-native-svg";

const MoneyFilledIcon = (props) => {
  return (
    <Svg
      width={25}
      height={24}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.677 10.172l.002 3.623c-.025.345-.058.69-.098 1.034a1.272 1.272 0 01-1.123 1.105c-1.84.206-3.743.206-5.583 0a1.272 1.272 0 01-1.122-1.105 24.341 24.341 0 010-5.657 1.272 1.272 0 011.122-1.105 25.346 25.346 0 015.583 0c.588.066 1.056.53 1.123 1.105.039.333.07.666.096 1zm-4.01.329a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"
        fill="#001533"
      />
      <Path
        d="M21.07 6.04c.156.27-.136.571-.445.537a26.846 26.846 0 00-5.917 0 2.772 2.772 0 00-2.445 2.421 25.846 25.846 0 000 6.005 2.773 2.773 0 002.445 2.422c1.95.218 3.966.218 5.917 0 .311-.035.605.268.448.54a4.97 4.97 0 01-3.78 2.449l-.651.069c-3.311.348-6.65.325-9.956-.069l-.432-.051a3.931 3.931 0 01-3.432-3.384 37.64 37.64 0 010-9.957A3.931 3.931 0 016.254 3.64l.432-.052a44.65 44.65 0 019.956-.068l.652.068A4.96 4.96 0 0121.07 6.04z"
        fill="#001533"
      />
    </Svg>
  );
};

export default MoneyFilledIcon;
